<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Route</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-exchange-form">

            <ng-container [formArrayName]="form.routeFormControlsRouteArraySelector">
                <div
                    *ngFor="let control of form.controls.routes; let i = index"
                    class="col-12"
                    [ngClass]="{'mb-3': control.errors.length > 0}"
                >
                    <app-checkbox
                        [formControlName]="i"
                        [control]="control"
                    >
                        <ng-container text>{{control.placeholder}}</ng-container>
                    </app-checkbox>
                </div>
                <div *ngIf='form.routesErrors.length > 0' class="form-text text-danger mt-3">
                    <span *ngFor="let error of form.routesErrors">{{error}}</span>
                </div>
            </ng-container>
        </form>
    </ng-container>
</app-dialog>
